"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LanguageSelect", {
  enumerable: true,
  get: function get() {
    return _Select.Select;
  }
});
var _Select = require("./Select");